export default class StickyNav {
    config = {
        header: null,
        position: null,
        height: null,
        offset: null
    }

    constructor() {
        this.init();
    }


    init() {
        let _t = this;

        _t.config.header      = $('.tm-header');
        _t.config.position    = _t.config.header.offset().top;
        _t.config.height      = _t.config.header.height();
        _t.config.offset      = 100;

        _t.isSticky();

        $(window).scroll(() => {
            _t.isSticky();
        });
    }

    isSticky() {
        let _t = this;
        let ScrollPosition = $(window).scrollTop();
        let NavPosition = _t.config.position + _t.config.height + _t.config.offset;

        // If the header should become sticky
        if (ScrollPosition > NavPosition && !_t.config.header.hasClass('sticky')) {
            _t.config.header.addClass('sticky');

            // Set initial opacity to 0
            _t.config.header.css('opacity', 0);

            // Animate slide down and opacity
            $({ y: -_t.config.height, opacity: 0 }).animate({ y: 0, opacity: 1 }, {
                duration: 200,
                step: function(now, fx) {
                    if (fx.prop === "y") {
                        _t.config.header.css('transform', 'translateY(' + now + '%)');
                    } else if (fx.prop === "opacity") {
                        _t.config.header.css('opacity', now); // Animate opacity
                    }
                }
            });

        } else if (ScrollPosition < NavPosition && _t.config.header.hasClass('sticky')) {

            // Animate slide up and opacity
            $({ y: 0, opacity: 1 }).animate({ y: -_t.config.height, opacity: 0 }, {
                duration: 200,
                step: function(now, fx) {
                    if (fx.prop === "y") {
                        _t.config.header.css('transform', 'translateY(' + now + '%)');
                    } else if (fx.prop === "opacity") {
                        _t.config.header.css('opacity', now); // Animate opacity
                    }
                },
                complete: function() {
                    _t.config.header.removeClass('sticky'); // Remove sticky class
                    _t.config.header.css('transform', 'translateY(0)'); // Reset transform
                    _t.config.header.css('top', _t.config.position); // Reset position
                    _t.config.header.css('opacity', 1); // Reset opacity
                }
            });
        }
    }

}


$(() => {
    if ($('.tm-header').length) new StickyNav()
})